
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { ChoroplethUS, DonutChart, ScatterPlot, StackBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function DevOpsKPI_ChangeVolume() {

    const [title] = useState("Change Volume - DevOpsKPI")
    const [summary] =  useState("Key Performance Indicators of Software deployment and development in BD MMS for Change Volume.")
    const [categories] = useState(["VolumeUp"])
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [filterLayout] = useState([
        {column:"Column", field:"column_name"},
        {column:"Filter Value", field: "value_name"},
        {column:"Product Type",field:"producttype"}
    ])
    const [revLayout] = useState([
        {column:"Grouping Value", field:"grouping"},
        {column:"Result", field: "value_name"}
    ])
    const [tfsLayout] = useState([
        {column:"Established TFS Value", field:"tfsValue"}
    ])

    const [bubbleColorOrgs, setBubColorOrgs] = useState(null)
    const [bubbleColorClosed, setBubColorClosed] = useState(null)
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        setBubColorOrgs(new Map([
            ["bd-devops", "#0062b1"],
            ["bd-pharmogistics", "#7b64ff"],
            ["bd-pyxis", "#fb9e00"],
            ["bd-architecture", "#68ccca"]
          ]))
          setBubColorClosed(new Map([
            ["Closed", "#FFA500"],
            ["Open", "#4169E1"]
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/DevOpsKPI_ChangeVolume/DevOpsKPI_ChangeVolume.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography>
                        <p>
                        Change Volume goes hand-in-hand with deployment frequency, and quantifies the number of new user stories or code changes the DevOps team delivers with each release, or in a given period of time.
                         </p>
                         <p>
                         DevOps KPI Change Volume major sources - Github, AWS Systems Manager and Jenkins Unit Testing. If a source is missing please comment on <a href="https://bddevops.atlassian.net/wiki/spaces/DEVOPS/pages/172359740/DevOps+KPI">Metric Development</a>.
                         </p>
                         <p>
                         <a href="/DevOpsKPI">Devops KPIs</a>
                         </p>
                        </Typography>
                        </div>
                    </Grid>
                </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                Github Metrics
                            </Typography>
                        </div>
                    </Grid>
              </Paper>


              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Total Github Code Added and Code Deleted over the last year.
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterCADValuesLastYear} axis={{x: "Date", y: "Code Changes"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeCADValuesLastYear} tooltip = {"Number of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            <p>
                            Github Metrics for the total code added and deleted over the last year. Changes in trend shows an increase or decrease in activity.
                            </p>
                            <p>
                            Code added happens when the code is changed. Looking at the delta of code added and code deleted is unfair as removing code can help improve efficiency.
                            </p>
                            <p>
                            Code churn gives a view into how much change is required by version rework. Code Churn is Code Added + Deleted + Modified.
                            </p>
                            </Typography>
                        </div>
                    </Grid>
            </Paper>

            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Code Churn by Project in Artifactory and Github
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBarChurnProjects}
                            axis = {{y:"Code Added"}}
                            tooltip={"Org:"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    <p>
                    Merge of Artifactory and Github to show the code Churn which is the total added, deleted and modified code.
                    </p>
                    <p>
                    Code churn doesn''t necessarily mean a problem as much as give an indication of high amount of rewrites or a low amount.
                    </p>
                            </Typography>
                    </div>
                </Paper>





            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Added Code by Github Organization.
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBarOrgA}
                            axis = {{y:"Code Added"}}
                            colors={bubbleColorOrgs}
                            tooltip={"Org:"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    <p>
                    Added Code is a measure of activity across organizations in BD MMS.
                    </p>
                    <p>
                    February 2022 skewes the overall data which will be normalized in the next graphic.
                    </p>
                            </Typography>
                    </div>
                </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Added Code by Github Organization.
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBarOrgA100}
                            axis = {{y:"Code Added"}}
                            colors={bubbleColorOrgs}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    <p>
                    Looking at a normalized by month of the total coded added by organization in BD MMS.
                    </p>
                    <p>
                    Comparing the Organization gives an idea of code development activity.
                    </p>
                            </Typography>
                    </div>
                </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            User Story Count for the last year from TFS
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackeduserStories}
                            axis = {{y:"Code Added"}}
                            tooltip={"Org:"}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of User Stories in TFS based on Davinci.
                            </Typography>
                    </div>
                </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            User Story Count for the last year from TFS Normalized
                             </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackeduserStories100}
                            axis = {{y:"Code Added"}}
                            tooltip={""}
                            colors={bubbleColorClosed}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Closed and Open state of User Stories in TFS based on Davinci normalized.
                            </Typography>
                    </div>
                </Paper>





            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Total Github Commits over the last year.
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterCADValuesLastYearCommit} axis={{x: "Data Extracted Date", y: "Commits"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeCADValuesLastYearCommit} tooltip = {"Commits: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Github Metrics for the total code  committed over the last year. Changes in trend shows an increase or decrease in activity.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>



                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Commits by Github Organization.
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBarOrgArtC}
                            axis = {{y:"Code Added"}}
                            colors={bubbleColorOrgs}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Total submitted code by organization.
                            </Typography>
                    </div>
                </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Commits by Github Organization Normalized.
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBarOrgArtC100}
                            axis = {{y:"Code Added"}}
                            colors={bubbleColorOrgs}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Total submitted code by organization normalized.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Github recorded Commits for Artifactory Projects
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scattercommitsLastYearArtifactory} axis={{x: "Date", y: "Commits"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangecommitsLastYearArtifactory} tooltip = {"Commits: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90","#157DD8","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Github Metrics for the total code committed over the last year to only artifactory projects.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>

             <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Added Code by Github Organization in Artifactory
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBarOrgArtCjfrogsearch}
                            axis = {{y:"Code Added"}}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Total submitted code by organization in Artifactory by project. Org is not interesting as the results are all bd pyxis currently.
                            </Typography>
                    </div>
                </Paper>






              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Github recorded Commits for Artifactory Projects in the last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutCommitsLastYear} colors={color.defaultScheme} tooltip={"Commits: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Blending the Github and Artifactory data to record the total amount of commits over the last year.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Github recorded Commits for Artifactory Projects in the last year by Organization
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedBarOrgArtC}
                            axis = {{y:"Commits"}}
                            colors={bubbleColorOrgs}
                            tooltip={"Date"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Blending the Github and Artifactory data to record the total amount of commits over the last year by Organization.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Total Github Code Added and Code Deleted
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterCADValues} axis={{x: "Date", y: "Code Changes"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeCADValues} tooltip = {"Code Changes: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Total Github Metrics for the total code added, deleted. Changes in trend shows an increase or decrease in activity.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>



            <Paper className="storySection">
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Total Github Commits
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterCADValuesCommit} axis={{x: "Date", y: "Commits"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeCADValuesCommit} tooltip = {"Number of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#9090ee","#15d8d2","#d87015"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Total Github Metrics for the total commits. Changes in trend shows an increase or decrease in activity.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>



                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                AWS Systems Manager
                            </Typography>
                        </div>
                    </Grid>
              </Paper>




            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            AWS Systems Manager Agent Deployment Records Per Definition
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedSSMdefinition}
                            axis = {{y:"Records"}}
                            colors={["#42a5f5","#ba68c8","#ef5350","#ff9800","#4caf50","#1976d2","#9c27b0","#d32f2f","#ed6c02","#2e7d32"]}
                            tooltip={"Definition"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Records of testing based on simplified definition for AWS Systems Manager Agent (SSM).
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            AWS Systems Manager Agent (SSM) Deployment Records Normalized
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedSSMdefinition100}
                            axis = {{y:"Records %"}}
                            colors={["#42a5f5","#ba68c8","#ef5350","#ff9800","#4caf50","#1976d2","#9c27b0","#d32f2f","#ed6c02","#2e7d32"]}
                            tooltip={"Definition"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Normalized look at the records of testing based on simplified definition for AWS Systems Manager Agent (SSM).
                            </Typography>
                    </div>
                </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                Jenkins Unit Testing
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Jenkins Unit Testing
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackeduserjenkinsinforesultshighlevel}
                            axis = {{y:"Records"}}
                            colors={["#42a5f5","#ba68c8","#ef5350","#ff9800","#4caf50","#1976d2","#9c27b0","#d32f2f","#ed6c02","#2e7d32"]}
                            tooltip={"Definition"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Records of how many unit tests were ran for reach project.

                            </Typography>
                    </div>
                </Paper>






            </div >
        )
    }
}

export default DevOpsKPI_ChangeVolume